import { render, staticRenderFns } from "./MonitoringDetail.vue?vue&type=template&id=48acc4f8&scoped=true"
import script from "./MonitoringDetail.vue?vue&type=script&lang=js"
export * from "./MonitoringDetail.vue?vue&type=script&lang=js"
import style0 from "./MonitoringDetail.vue?vue&type=style&index=0&id=48acc4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48acc4f8",
  null
  
)

export default component.exports